import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { AuthToken, TokenService } from '../services/token.service';
import { HttpCacheService } from '../services/http-cache-service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService,
        private router: Router,
        private tokenService: TokenService,
        private httpCacheService: HttpCacheService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler) {

        if (!request.headers?.has('Authorization')) {

            const token = this.tokenService.getToken();
            if (token.isValid()) {
                // console.log("token.getValue()", token.getValue());
                const authReq = request.clone({
                    setHeaders: {
                        Authorization: token.getValue()
                    }
                    //headers: request.headers?.set('Authorization', token.getValue())
                });
                // console.log("AuthInterceptor", "token.isValid()", request);
                return next.handle(authReq).pipe(catchError((error) => this.handleError(error)));
            } else {
                // console.log("AuthInterceptor", "token.isInValid()", request);
                return next.handle(request).pipe(catchError((error) => this.handleError(error)));
            }
        } else {
            // console.log("AuthInterceptor", "no Authorization header", request);
            return next.handle(request).pipe(catchError((error) => this.handleError(error)));
        }
    }

    private handleError(error: HttpErrorResponse): Observable<HttpEvent<any>> {
        if (error.status === 401) {
            this.tokenService.clear();
            this.httpCacheService.clearCache();
            this.router.navigateByUrl("/auth/login");
        } else if (error.status === 403) {
            // Handle 403 (Forbidden) without propagating the error
            console.log("アクセス権限エラー", error);
            return of(error as any); // return an empty observable
            // return of(new HttpResponse({ status: 403 })); 
        } else {
            console.log("handleError", error);
        }
        return throwError(error);
    }

}